import React, { useRef, useState } from "react";
import { FaFileUpload, FaSpinner } from "react-icons/fa";
import { MdAddCircleOutline } from "react-icons/md";
import "./DropZone.scss";
const DropZone = (props) => {
  const [drag, setDrag] = useState(false);
  const fileInputRef = useRef();
  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
    setDrag(true);
  };

  const dragLeave = (e) => {
    e.preventDefault();
    let rect = document
      .getElementById(`drop-container${props.id}`)
      .getBoundingClientRect();
    if (
      e.clientY < rect.top ||
      e.clientY >= rect.bottom ||
      e.clientX < rect.left ||
      e.clientX >= rect.right
    ) {
      //real leave
      setDrag(false);
    }
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };
  const filesSelected = () => {
    if (fileInputRef.current.files.length) {
      if (props.onSubmit) {
        props.onSubmit(fileInputRef.current.files);
      }
    }
  };
  const fileDrop = (e) => {
    e.preventDefault();
    setDrag(false);
    const files = e.dataTransfer.files;
    if (files && files.length) {
      if (props.onSubmit) {
        props.onSubmit(files);
      }
    }
  };
  return (
    <div
      className="drop-container h-100"
      id={`drop-container${props.id}`}
      onDragOver={dragOver}
      onDragEnter={dragEnter}
      onDragLeave={dragLeave}
      onDrop={fileDrop}
    >
      <div className="d-flex flex-column align-items-center">
        <div className="drop-message">
          <MdAddCircleOutline></MdAddCircleOutline>
          <span>Drop file here</span>
        </div>
        <a onClick={fileInputClicked} className="secondary browse">
          Browse Files
        </a>
        <input
          ref={fileInputRef}
          className="file-input"
          type="file"
          multiple
          onChange={filesSelected}
        />
      </div>

      {drag && (
        <div className="box__uploading">
          <FaFileUpload></FaFileUpload>
          <span>{props.errorMessage || "Drop to Upload HR Data"}</span>
        </div>
      )}
      {props.uploading && (
        <div className="box__uploading">
          <FaSpinner></FaSpinner>
          <span>Uploading....</span>
        </div>
      )}
    </div>
  );
};
export default DropZone;
